import React from "react";

function UtilityIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 21 21">
      <g transform="translate(-0.461 0)">
        <path
          d="M6.378,307.907a3.252,3.252,0,0,0,.928-2.786v0a3.273,3.273,0,0,0-2.788-2.79,3.222,3.222,0,0,0-2.789.927l-.435.434a2.833,2.833,0,0,0-.722,2.788l1.415-1.414a1.827,1.827,0,1,1,2.583,2.583l-1.414,1.414a2.841,2.841,0,0,0,2.787-.72Zm0,0"
          transform="translate(0 -288.171)"
          fill="#fff"
        />
        <path
          d="M117.666,227.794l-1.551-1.551L115,227.354a11.156,11.156,0,0,1-2.577,1.93c.037.015.068.033.1.048.07.031.139.062.207.1.049.025.1.052.144.079s.114.065.169.1.1.062.143.095.106.077.158.117.09.068.134.1c.059.05.116.1.173.156.03.028.061.052.09.081s.05.057.076.084c.056.059.11.119.163.181.034.04.065.083.1.124s.087.113.127.172c.029.042.057.084.084.127.041.065.08.131.117.2.022.036.043.076.063.115q.073.139.132.283c.005.013.012.025.017.037a11.264,11.264,0,0,1,1.931-2.578Zm0,0"
          transform="translate(-106.693 -215.699)"
          fill="#fff"
        />
        <path
          d="M9.358,6.265A.366.366,0,0,1,9.011,6l-.175-.624L4,.535A1.829,1.829,0,0,0,1.416,3.123L6.235,7.94l.649.193a.365.365,0,0,1,.261.338l.031.923.122.122,3.1-3.1-.138-.138Zm0,0"
          transform="translate(-0.4 0)"
          fill="#fff"
        />
        <path
          d="M394.052,397.556l.61-.61-.813-1.22-.711-.356-.661.661.355.711Zm0,0"
          transform="translate(-373.637 -376.999)"
          fill="#fff"
        />
        <path
          d="M227.148,119.015l.25.25,1.3,1.3.933-.933a11.307,11.307,0,0,1,2.579-1.93l-.01,0c-.11-.045-.216-.1-.32-.149l-.084-.046q-.119-.065-.233-.138l-.1-.065c-.069-.047-.137-.1-.2-.149-.034-.027-.068-.052-.1-.079-.064-.053-.124-.11-.185-.167-.028-.026-.058-.05-.086-.077s-.065-.073-.1-.11-.093-.1-.137-.151-.075-.1-.112-.143l-.11-.146c-.037-.049-.068-.1-.1-.151s-.064-.106-.095-.159-.058-.1-.085-.153-.06-.126-.088-.19c-.017-.039-.037-.076-.054-.115a11.264,11.264,0,0,1-1.932,2.575Zm0,0"
          transform="translate(-216.017 -110.126)"
          fill="#fff"
        />
        <path
          d="M300.294,4.695a3.266,3.266,0,0,0-.962,2.325,3.074,3.074,0,0,0,.035.459,3.256,3.256,0,0,0,.928,1.866,3.329,3.329,0,0,0,.4.344,3.256,3.256,0,0,0,.439.265l.022.011a3.271,3.271,0,0,0,.465.186l.022.007a3.323,3.323,0,0,0,.5.112h.008a3.257,3.257,0,0,0,2.787-.927l.434-.434a2.844,2.844,0,0,0,.722-2.789l-1.414,1.414A1.827,1.827,0,1,1,302.1,4.951l1.414-1.415a2.835,2.835,0,0,0-2.789.722Zm0,0"
          transform="translate(-284.747 -3.269)"
          fill="#fff"
        />
        <path
          d="M180.988,180.6l.517-.517,9.3,9.3-.517.517Zm0,0"
          transform="translate(-171.808 -171.543)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export { UtilityIcon };
